export const COVER_CONTENT_TYPE_VALUES = ["image/jpeg", "image/png", "image/webp"];
export const AVATAR_CONTENT_TYPE_VALUES = COVER_CONTENT_TYPE_VALUES;
